const finiteNumber = (value, label) => {
  const parsed = Number(value);
  if (!Number.isFinite(parsed)) throw new Error(`${label} must be a finite number`);
  return parsed;
};

export const fractionToPercent = (value) => (
  Math.round(finiteNumber(value, 'Stored fraction') * 100 * 1e8) / 1e8
);

export const percentToFraction = (value) => (
  Math.round((finiteNumber(value, 'Percentage') / 100) * 1e10) / 1e10
);

export const formatPercent = (value, maximumFractionDigits = 2) => {
  const parsed = finiteNumber(value, 'Percentage');
  return `${new Intl.NumberFormat(undefined, {
    maximumFractionDigits,
  }).format(parsed)}%`;
};

export const validateAllocationPercent = (value, minimum = 0.01, maximum = 100) => {
  if (String(value ?? '').trim() === '') return 'Enter a valid percentage.';
  const parsed = Number(value);
  if (!Number.isFinite(parsed)) return 'Enter a valid percentage.';
  if (parsed < minimum || parsed > maximum) {
    return `Enter a percentage from ${minimum}% to ${maximum}%.`;
  }
  return '';
};
